import { colors } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import { CTN, SH3 } from '@zet/design-system/typography'

import { LabelComponentType } from './types'

type Props = {
  isFocused: boolean
  text: string
  labelLeftComponent?: LabelComponentType
  labelRightComponent?: LabelComponentType
  subText?: string | number | undefined
  activeTextColor?: string
}

const TabLabel = ({
  isFocused,
  text,
  labelLeftComponent,
  labelRightComponent,
  subText,
  activeTextColor,
}: Props) => {
  return (
    <XStack className="items-center justify-center">
      {isFocused && labelLeftComponent
        ? labelLeftComponent.activeComponent
        : labelLeftComponent?.inActiveComponent}
      <SH3
        className={'mx-1'}
        style={{
          color: isFocused
            ? activeTextColor || colors.primary[50]
            : colors.grays[50],
        }}
      >
        {text}
      </SH3>
      {subText && (
        <Stack>
          <CTN
            className={` rounded-3xl px-1 ${
              isFocused
                ? 'bg-grays-80 text-grays-20'
                : 'bg-grays-40 text-grays-50'
            }`}
          >
            {subText}
          </CTN>
        </Stack>
      )}
      {isFocused && labelRightComponent
        ? labelRightComponent.activeComponent
        : labelRightComponent?.inActiveComponent}
    </XStack>
  )
}

export default TabLabel
